"use client";
// import { ResumeData } from "@/lib/schema";

// // Helper function to handle both old and new language formats
// const getLanguageName = (lang: string | { name: string }): string => {
//   return typeof lang === 'string' ? lang : lang.name;
// };

// export default function ClassicPhoto({ data }: { data: ResumeData }) {
//   return (
//     <div className="p-6 font-serif text-gray-700">
//       {/* Header Section with Photo */}
//       <div className="flex items-start gap-6 mb-6">
//         {/* Profile Photo */}
//         {data.basics.photo && (
//           <div className="flex-shrink-0 print:overflow-visible print:max-w-none">
//             <img
//               src={data.basics.photo}
//               alt="Profile"
//               className="w-32 h-32 rounded-full border-4 border-gray-300 object-cover shadow-lg print:max-w-32 print:max-h-32 print:object-cover print:border print:border-gray-400 print:shadow-none"
//             />
//           </div>
//         )}
        
//         {/* Name and Contact Info */}
//         <div className="flex-1">
//           <h1 className="text-3xl font-bold mb-2">{data.basics.name}</h1>
//           <p className="italic text-lg mb-2">{data.basics.title}</p>
//           <p className="text-sm mb-3">
//             {data.basics.email} | {data.basics.phone}
//             {data.basics.location ? ` | ${data.basics.location}` : ''}
//           </p>
//           {data.basics.summary && (
//             <p className="text-sm leading-relaxed">{data.basics.summary}</p>
//           )}
//         </div>
//       </div>

//       <hr className="my-4 border-gray-400" />

//       {/* Experience Section */}
//       <h2 className="font-bold text-xl text-black mb-3">Experience</h2>
//       {data.experience.map((exp, i) => (
//         <div key={i} className="mb-4">
//           <p className="text-lg text-black font-semibold">{exp.role} — {exp.company}</p>
//           <p className="text-sm text-gray-600 mb-1">{exp.startDate} - {exp.current ? 'Present' : exp.endDate}</p>
//           {exp.summary && <p className="mt-1 text-sm leading-relaxed">{exp.summary}</p>}
//         </div>
//       ))}

//       {/* Education Section */}
//       <h2 className="font-bold text-xl mt-6 text-black mb-3">Education</h2>
//       {data.education.map((edu, i) => (
//         <div key={i} className="mb-3">
//           <p className="text-lg text-black font-semibold">{edu.degree} — {edu.institution}</p>
//           <p className="text-sm text-gray-600">{edu.startDate} - {edu.endDate}</p>
//         </div>
//       ))}

//       {/* Skills Section */}
//       <h2 className="font-bold text-xl mt-6 text-black mb-3">Skills</h2>
//       <p className="leading-relaxed">{data.skills.join(", ")}</p>

//       {/* Strengths Section - Only show if data exists */}
//       {data.basics.strengths && data.basics.strengths.length > 0 && (
//         <>
//           <h2 className="font-bold text-xl mt-6 text-black mb-3">Strengths</h2>
//           <div className="space-y-3">
//             {data.basics.strengths.map((strength, i) => (
//               <div key={i}>
//                 <p className="font-semibold text-black">{strength.title}</p>
//                 {strength.description && (
//                   <p className="text-sm text-gray-600 leading-relaxed">{strength.description}</p>
//                 )}
//               </div>
//             ))}
//           </div>
//         </>
//       )}

//       {/* Key Achievements Section - Only show if data exists */}
//       {data.basics.achievements && data.basics.achievements.length > 0 && (
//         <>
//           <h2 className="font-bold text-xl mt-6 text-black mb-3">Key Achievements</h2>
//           <div className="space-y-3">
//             {data.basics.achievements.map((achievement, i) => (
//               <div key={i}>
//                 <p className="font-semibold text-black">{achievement.title}</p>
//                 {achievement.description && (
//                   <p className="text-sm text-gray-600 leading-relaxed">{achievement.description}</p>
//                 )}
//               </div>
//             ))}
//           </div>
//         </>
//       )}

//       {/* Languages Section */}
//       {data.basics.languages && data.basics.languages.length > 0 && (
//         <>
//           <h2 className="font-bold text-xl mt-6 text-black mb-3">Languages</h2>
//           <p className="leading-relaxed">
//             {Array.isArray(data.basics.languages)
//               ? data.basics.languages
//                   .map((lang) => getLanguageName(lang as string | { name: string }))
//                   .join(", ")
//               : ""}
//           </p>
//         </>
//       )}

//       {/* Social Links Section */}
//       {data.basics.social && data.basics.social.length > 0 && (
//         <>
//           <h2 className="font-bold text-xl mt-6 text-black mb-3">Social Links</h2>
//           <ul className="space-y-1">
//             {data.basics.social.map((link, i) => (
//               <li key={i} className="text-sm">
//                 <span className="font-semibold">{link.label}:</span>{" "}
//                 <a 
//                   href={link.url} 
//                   className="text-blue-600 underline hover:text-blue-800 transition-colors" 
//                   target="_blank" 
//                   rel="noopener noreferrer"
//                 >
//                   {link.url}
//                 </a>
//               </li>
//             ))}
//           </ul>
//         </>
//       )}

//       {/* Hobbies & Interests Section */}
//       {data.basics.hobbies && data.basics.hobbies.length > 0 && (
//         <>
//           <h2 className="font-bold text-xl mt-6 text-black mb-3">Hobbies & Interests</h2>
//           <p className="leading-relaxed">{data.basics.hobbies.join(", ")}</p>
//         </>
//       )}
//     </div>
//   );
// }


import React from "react";
import { ResumeData } from "@/lib/schema";

const getLanguageName = (lang: string | { name: string }): string =>
  typeof lang === "string" ? lang : lang.name;

interface ClassicPhotoProps {
  data: ResumeData;
}

const styles = {
  container: {
    padding: "24px",
    fontFamily: "serif",
    color: "#374151", // gray-700
  } as React.CSSProperties,
  headerSection: {
    display: "flex",
    alignItems: "flex-start",
    gap: "24px",
    marginBottom: "24px",
  } as React.CSSProperties,
  profilePhotoWrapper: {
    flexShrink: 0,
    overflow: "visible",
    maxWidth: "128px",
  } as React.CSSProperties,
  profilePhoto: {
    width: "128px",
    height: "128px",
    borderRadius: "50%",
    borderWidth: "4px",
    borderStyle: "solid",
    borderColor: "#d1d5db", // gray-300
    objectFit: "cover",
    boxShadow: "0 10px 15px -3px rgb(0 0 0 / 0.1)",
  } as React.CSSProperties,
  name: {
    fontSize: "24px",
    fontWeight: "700",
    marginBottom: "8px",
    color: "#000",
  } as React.CSSProperties,
  title: {
    fontStyle: "italic",
    fontSize: "18px",
    marginBottom: "8px",
  } as React.CSSProperties,
  contactInfo: {
    fontSize: "14px",
    marginBottom: "12px",
  } as React.CSSProperties,
  summary: {
    fontSize: "14px",
    lineHeight: "1.5",
  } as React.CSSProperties,
  hr: {
    borderTop: "1px solid #9ca3af", // gray-400
    margin: "16px 0",
  } as React.CSSProperties,
  sectionTitle: {
    fontWeight: "700",
    fontSize: "20px",
    marginBottom: "12px",
    color: "#000",
  } as React.CSSProperties,
  experienceItem: {
    marginBottom: "16px",
  } as React.CSSProperties,
  experienceRole: {
    fontSize: "18px",
    fontWeight: "600",
    color: "#000",
  } as React.CSSProperties,
  experienceDate: {
    fontSize: "14px",
    color: "#4b5563", // gray-600
    marginBottom: "4px",
  } as React.CSSProperties,
  experienceSummary: {
    marginTop: "4px",
    fontSize: "14px",
    lineHeight: "1.5",
  } as React.CSSProperties,
  educationItem: {
    marginBottom: "12px",
  } as React.CSSProperties,
  educationDegree: {
    fontSize: "18px",
    fontWeight: "600",
    color: "#000",
  } as React.CSSProperties,
  educationDate: {
    fontSize: "14px",
    color: "#4b5563",
  } as React.CSSProperties,
  skillsText: {
    fontSize: "14px",
    lineHeight: "1.5",
  } as React.CSSProperties,
  strengthItem: {
    marginBottom: "12px",
  } as React.CSSProperties,
  strengthTitle: {
    fontWeight: "600",
    color: "#000",
  } as React.CSSProperties,
  strengthDescription: {
    fontSize: "14px",
    color: "#4b5563",
    lineHeight: "1.5",
  } as React.CSSProperties,
  socialList: {
    marginTop: "8px",
    paddingLeft: "16px",
  } as React.CSSProperties,
  socialItem: {
    fontSize: "14px",
    marginBottom: "8px",
  } as React.CSSProperties,
  socialLabel: {
    fontWeight: "600",
  } as React.CSSProperties,
  socialLink: {
    color: "#2563eb", // blue-600
    textDecoration: "underline",
  } as React.CSSProperties,
  hobbiesText: {
    fontSize: "14px",
    lineHeight: "1.5",
  } as React.CSSProperties,
};

export default function ClassicPhoto({ data }: ClassicPhotoProps) {
  return (
    <div style={styles.container}>
      {/* Header Section with Photo */}
      <div style={styles.headerSection}>
        {/* Profile Photo */}
        {data.basics.photo && (
          <div style={styles.profilePhotoWrapper}>
            <img
              src={data.basics.photo}
              alt="Profile"
              style={styles.profilePhoto}
            />
          </div>
        )}

        {/* Name and Contact Info */}
        <div style={{ flex: 1 }}>
          <h1 style={styles.name}>{data.basics.name}</h1>
          <p style={styles.title}>{data.basics.title}</p>
          <p style={styles.contactInfo}>
            {data.basics.email} | {data.basics.phone}
            {data.basics.location ? ` | ${data.basics.location}` : ""}
          </p>
          {data.basics.summary && (
            <p style={styles.summary}>{data.basics.summary}</p>
          )}
        </div>
      </div>

      <hr style={styles.hr} />

      {/* Experience Section */}
      <h2 style={styles.sectionTitle}>Experience</h2>
      {data.experience.map((exp, i) => (
        <div key={i} style={styles.experienceItem}>
          <p style={styles.experienceRole}>
            {exp.role} — {exp.company}
          </p>
          <p style={styles.experienceDate}>
            {exp.startDate} - {exp.current ? "Present" : exp.endDate}
          </p>
          {exp.summary && <p style={styles.experienceSummary}>{exp.summary}</p>}
        </div>
      ))}

      {/* Education Section */}
      <h2 style={styles.sectionTitle}>Education</h2>
      {data.education.map((edu, i) => (
        <div key={i} style={styles.educationItem}>
          <p style={styles.educationDegree}>
            {edu.degree} — {edu.institution}
          </p>
          <p style={styles.educationDate}>
            {edu.startDate} - {edu.endDate}
          </p>
        </div>
      ))}

      {/* Skills Section */}
      <h2 style={styles.sectionTitle}>Skills</h2>
      <p style={styles.skillsText}>{data.skills.join(", ")}</p>

      {/* Strengths Section */}
      {data.basics.strengths && data.basics.strengths.length > 0 && (
        <>
          <h2 style={styles.sectionTitle}>Strengths</h2>
          <div>
            {data.basics.strengths.map((strength, i) => (
              <div key={i} style={styles.strengthItem}>
                <p style={styles.strengthTitle}>{strength.title}</p>
                {strength.description && (
                  <p style={styles.strengthDescription}>{strength.description}</p>
                )}
              </div>
            ))}
          </div>
        </>
      )}

      {/* Key Achievements Section */}
      {data.basics.achievements && data.basics.achievements.length > 0 && (
        <>
          <h2 style={styles.sectionTitle}>Key Achievements</h2>
          <div>
            {data.basics.achievements.map((achievement, i) => (
              <div key={i} style={styles.strengthItem}>
                <p style={styles.strengthTitle}>{achievement.title}</p>
                {achievement.description && (
                  <p style={styles.strengthDescription}>{achievement.description}</p>
                )}
              </div>
            ))}
          </div>
        </>
      )}

      {/* Languages Section */}
      {data.basics.languages && data.basics.languages.length > 0 && (
        <>
          <h2 style={styles.sectionTitle}>Languages</h2>
          <p style={styles.skillsText}>
            {Array.isArray(data.basics.languages)
              ? data.basics.languages
                  .map((lang) => getLanguageName(lang as string | { name: string }))
                  .join(", ")
              : ""}
          </p>
        </>
      )}

      {/* Social Links Section */}
      {data.basics.social && data.basics.social.length > 0 && (
        <>
          <h2 style={styles.sectionTitle}>Social Links</h2>
          <ul style={styles.socialList}>
            {data.basics.social.map((link, i) => (
              <li key={i} style={styles.socialItem}>
                <span style={styles.socialLabel}>{link.label}:</span>{" "}
                <a
                  href={link.url}
                  style={styles.socialLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {link.url}
                </a>
              </li>
            ))}
          </ul>
        </>
      )}

      {/* Hobbies & Interests Section */}
      {data.basics.hobbies && data.basics.hobbies.length > 0 && (
        <>
          <h2 style={styles.sectionTitle}>Hobbies & Interests</h2>
          <p style={styles.skillsText}>{data.basics.hobbies.join(", ")}</p>
        </>
      )}
    </div>
  );
}
